import { Bar } from 'vue-chartjs'
export default {
  extends: Bar,

  props: ['chartData'],
  data: () => ({
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend:{
        display: false
      },
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
            min: 0,
            max: 5,
            stepSize: 1
          }
        }]
      },
    },
  }),

  mounted () {
    this.renderChart(this.chartData, this.options)
  },

  methods: {
    resetChart: function() {
      this.renderChart(this.chartData, this.options)
    }
  },
}
